import { render } from "./LanguageSetup.vue?vue&type=template&id=25363d63&scoped=true"
import script from "./LanguageSetup.vue?vue&type=script&lang=js"
export * from "./LanguageSetup.vue?vue&type=script&lang=js"

import "./LanguageSetup.vue?vue&type=style&index=0&id=25363d63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25363d63"]])

export default __exports__